import Customer from "@/model/customer";
import deliveryDestinationApi from "@/api/deliveryDestinationApi";

export interface IMDeliveryDestination {
  cart_dlv_dst_code?: string;
  dlv_dst_name: string;
  postal_code: string;
  address_1: string;
  address_2: string;
  tel_number: string;
  supervisor_name: string;
  delete_kbn: string;
  div_fmt_code: string;
  div_fmt_note: string;
  customer_code: string;
  prefectures_code: string;
  prefectures_name: string;
  customer: Customer;
}

export class MDeliveryDestinationDTO implements IMDeliveryDestination {
  cart_dlv_dst_code?: string;
  dlv_dst_name: string;
  postal_code: string;
  address_1: string;
  address_2: string;
  tel_number: string;
  supervisor_name: string;
  delete_kbn: string;
  div_fmt_code: string;
  div_fmt_note: string;
  customer_code: string;
  prefectures_code: string;
  prefectures_name: string;
  customer: Customer;
}

export default class MDeliveryDestination extends MDeliveryDestinationDTO {
  constructor(dto?: MDeliveryDestinationDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }
  public new() {
    Object.assign(this, {
      cart_dlv_dst_code: "",
      dlv_dst_name: "",
      postal_code: "",
      address_1: "",
      address_2: "",
      tel_number: "",
      supervisor_name: "",
      delete_kbn: "",
      div_fmt_code: "",
      div_fmt_note: "",
      customer_code: "",
      prefectures_code: "",
      customer: {},
    });
  }

  get formatPostalCode() {
    let postalCode = this.postal_code;
    console.log('Delivery destination:', postalCode.includes('-'));
    if (!postalCode.includes('-')) {
      postalCode = postalCode.slice(0, 3) + '-' + postalCode.slice(-4);
    }

    return postalCode;
  }

  get address() {
    return "〒" + this.formatPostalCode + "　" + this.address_1.trim() + this.address_2.trim();
  }
  public async add() {
    return await deliveryDestinationApi.add(this);
  }
  public async update() {
    return await deliveryDestinationApi.update(this.cart_dlv_dst_code, this);
  }
  public async delete() {
    await deliveryDestinationApi.delete(this.cart_dlv_dst_code);
  }
}
